import { Component, OnInit } from "@angular/core";
import {
  BsDatepickerConfig,
  BsDatepickerModule,
} from "ngx-bootstrap/datepicker";
import { CoreService } from "../../services/coreService";
import { UserGroups } from "../../../assets/config/models";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

declare var toastr: any;

@Component({
  selector: "dashboard-header",
  templateUrl: "./dashboard-header.component.html",
  styleUrls: ["./dashboard-header.component.scss"],
  providers: [CoreService],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, BsDatepickerModule],
})
export class DashboardHeaderComponent implements OnInit {
  bsConfig!: Partial<BsDatepickerConfig>;
  dashboardDate: Date[] = [];
  dashboardData: any;
  group: any;
  groupTypes = UserGroups;
  loading = false;
  constructor(private coreService: CoreService) {
    this.group = JSON.parse(localStorage.getItem("user_details")!).group;
  }

  onDashboardDateRangeChanged() {
    console.log(this.dashboardDate);
    this.fetchDashboard(this.dashboardDate);
  }

  fetchDashboard(date: Date[] | null) {
    this.loading = true;
    this.coreService
      .GetDashboardData(date)
      .then((response) => {
        this.dashboardData = response;
        console.log("data is: ", response);
        this.loading = false;
      })
      .catch((err) => {
        toastr.error("", "Failed to fetch dashboard data", {
          timeOut: 2000,
        });
        this.loading = false;
      });
  }

  resetDate() {
    this.dashboardDate = [];
    this.fetchDashboard(null);
  }

  ngOnInit() {
    this.fetchDashboard(null);
  }
}
